<template>
  <div class="container">
    <h4 class="title is-4">About</h4>
    <div class="level">
      <div class="level-left">
        <div class="level-item">App version: {{appVersion}}</div>
      </div>
      <div class="level-left">
        <div class="level-item">Engine version: {{engineVersion}}</div>
      </div>
      <div class="level-left">
        <div class="level-item">UI version: {{uiVersion}}</div>
      </div>
    </div>
    <hr/>
    <div class="container has-text-left">
      <div class="block">
        Engine init time: <span>{{displayedInitTimestamp}}</span>
      </div>
      <div class="block">
        Engine restarts: <span>{{engineRestarts.length}}</span>
      </div>
      <div class="block" v-if="engineRestarts.length > 0">
        Engine last restart: <span>{{displayedLastRestart}}</span>
      </div>
    </div>
    <hr/>
    <div class="container has-text-left">
      <div class="block">
        <b-input type="textarea" :value="accessToken" readonly="true"></b-input>
      </div>
    </div>

    <template v-if="isGeolocationSupported && isGeolocation">
      <hr />
      <div class="container has-text-left">
        <div class="block">
          Geo coordinates: <span>{{displayedGeoCoordinates}}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {formatTime} from '../utils/utils';
  import BInput from "buefy/src/components/input/Input";

  export default {
    components: { BInput },
    name: "screenabout",
    computed: {
      ...mapGetters('ui', ['versions', 'engineInitTimestamp', 'engineRestarts', 'geolocationSupported', 'geolocation']),
      ...mapGetters('auth', ['token']),
      displayedInitTimestamp() {
        return formatTime(this.engineInitTimestamp);
      },
      displayedLastRestart() {
        return this.engineRestarts.length > 0 ? formatTime(this.engineRestarts[0]) : '-';
      },
      appVersion() {
        return this.versions.app;
      },
      engineVersion() {
        return this.versions.engine;
      },
      uiVersion() {
        return this.versions.ui;
      },
      accessToken() {
        return this.token;
      },
      isGeolocationSupported() {
        return this.geolocationSupported;
      },
      isGeolocation() {
        return this.geolocation && this.geolocation.coords;
      },
      displayedGeoCoordinates() {
        return this.isGeolocation ? `${this.geolocation.coords.latitude}, ${this.geolocation.coords.longitude}` : '-';
      }
    }
  }
</script>

<style scoped>

</style>
